import * as Sentry from '@sentry/react';
import { useEffect, useMemo } from 'react';
import { useRoutes } from 'react-router-dom';

import { Toaster } from 'react-hot-toast';
import { CssBaseline, ThemeProvider, StyledEngineProvider } from '@mui/material';
import SettingsDrawer from './components/SettingsDrawer';
import SplashScreen from './components/SplashScreen';
import { gtmConfig } from './config';
import useAuth from './hooks/useAuth';
// import useScrollReset from './hooks/useScrollReset'; BORRAR
import useSettings from './hooks/useSettings';
import gtm from './lib/gtm';
import routes from './routes';
import { createCustomTheme } from './theme';
import './App.css';

const useSentryRoutes = Sentry.wrapUseRoutesV6(useRoutes);

function App() {
  const content = useSentryRoutes(routes);
  const { settings } = useSettings();
  const auth = useAuth();

  // useScrollReset();

  useEffect(() => {
    gtm.initialize(gtmConfig);
  }, []);

  const theme = useMemo(
    () =>
      createCustomTheme({
        responsiveFontSizes: settings.responsiveFontSizes,
        roundedCorners: settings.roundedCorners,
        theme: settings.theme,
      }),
    [settings.responsiveFontSizes, settings.roundedCorners, settings.theme]
  );

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster position="top-center" />
        <SettingsDrawer />
        {auth.isInitialized ? content : <SplashScreen />}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
